import { create } from 'zustand';

/**
 * The toss drawer: "Toss the ball" opens the request composer in a wide drawer
 * over the page you are on (owner request 2026-11-03), instead of taking you to
 * the composer's own page and away from the cycle or track you were working in.
 * The composer's page stays for links from notifications and email.
 */
interface TossDrawerState {
  open: { cycleId: string; trackId?: string } | null;
  openToss: (cycleId: string, trackId?: string) => void;
  close: () => void;
}

export const useTossDrawerStore = create<TossDrawerState>((set) => ({
  open: null,
  openToss: (cycleId, trackId) => set({ open: { cycleId, trackId } }),
  close: () => set({ open: null }),
}));
